import styled from 'styled-components';

export const FooterContent = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;